import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/Home'
import Solution from '@/components/Solution'
import Services from '@/components/Services'
import Tips from '@/components/Tips'
import Clients from '@/components/Clients'
import Contacts from '@/components/Contacts'
import About from '@/components/About'
import GDPR from '@/components/GDPR'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/tips',
    name: 'Tips',
    component: Tips
  },
  {
    path: '/clients/:category?/:client?',
    name: 'Clients',
    component: Clients
  },
  {
    path: '/services',
    name: 'Services',
    component: Services
  },
  {
    path: '/contacts',
    name: 'Contacts',
    component: Contacts
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/gdpr',
    name: 'GDPR',
    component: GDPR
  },
  {
    path: '/:category',
    name: 'HomeCategorySelected',
    component: Home
  },
  {
    path: '/:category/:solution',
    name: 'Solution',
    component: Solution
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js